// extracted by mini-css-extract-plugin
export var activeFilterButton = "_sn-c";
export var backButton = "_sn-4";
export var backIcon = "_sn-5";
export var chevronShortcut = "_sn-6";
export var container = "_sn-1";
export var editor = "_sn-8";
export var editorWrapper = "_sn-7";
export var prefix = "_sn-2";
export var searchIcon = "_sn-3";
export var suffix = "_sn-9";
export var suffixContent = "_sn-a";
export var suffixText = "_sn-b";
export var wrapper = "_sn-0";